import { institutionsRoutePaths } from './paths';

import type { RouteObject } from 'react-router-dom';

export const institutionsRoutes: RouteObject[] = [
  {
    path: institutionsRoutePaths.list.path,
    async lazy() {
      const Page = await import('@/pages/institutions');
      return { Component: Page.default };
    },
  },
  {
    // 정적 경로가 :cik 보다 우선한다(React Router 순위) — 'divergences' 는 cik 형식(10자리 숫자)이 아니다.
    path: institutionsRoutePaths.divergences.path,
    async lazy() {
      const Page = await import('@/pages/institutions/DivergencesPage');
      return { Component: Page.default };
    },
  },
  {
    path: institutionsRoutePaths.detail.path,
    async lazy() {
      const Page = await import('@/pages/institutions/InstitutionDetailPage');
      return { Component: Page.default };
    },
  },
];
